// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ec-0";
export var fileCarousel = "_ec-2";
export var removeFileButton = "_ec-1";